// Lo que se cobrará por una reserva, calculado igual que el servidor (calcMontoBooking de routes/api/bookings.js y descuentoPara de
// models/PromoCode.js): el precio por las horas o los días del servicio, menos el código promocional. En una reserva que viene de una
// cotización el servidor guarda el precio negociado sin tipo de cobro, así que ese precio ya es el total.
import { MINIMO_COBRO } from '../../utils/reglasPago';

// Cuántas horas o días se cobran (redondeadas a décimas, como en el servidor); 1 si el precio es por servicio.
export const unidadesDe = ({ tipoCosto, duracionMinutos } = {}) => {
  const mins = duracionMinutos || 0;
  if (tipoCosto === 'Hora') return Math.round((mins / 60) * 10) / 10;
  if (tipoCosto === 'Día') return Math.round((mins / (60 * 24)) * 10) / 10;
  return 1;
};

const aCentavos = (n) => Math.round(n * 100) / 100;

// reserva: la que devuelve POST /api/bookings (costoServicio, tipoCosto, duracionMinutos). promo: el código aplicado
// ({ tipo, descuentoPct, montoFijo }) o null; si la reserva se creó con él, el servidor ya comprobó que aplica.
export const montoDeReserva = (reserva, promo) => {
  const valor = parseFloat(reserva?.costoServicio);
  const precio = valor > 0 ? valor : 0;
  const unidades = unidadesDe(reserva || {});
  const subtotal = aCentavos(precio * unidades);
  const bruto = !promo ? 0
    : promo.tipo === 'monto_fijo' ? (promo.montoFijo || 0)
    : Math.round(subtotal * (promo.descuentoPct || 0)) / 100;
  // Como en el servidor: un código nunca deja la reserva por debajo de lo mínimo que se cobra
  const descuento = Math.min(aCentavos(bruto), Math.max(0, aCentavos(subtotal - MINIMO_COBRO)));
  return { precio, unidades, subtotal, descuento, total: aCentavos(subtotal - descuento) };
};
